module.exports = __webpack_public_path__ + "img/delano8.aec28483.jpg";